var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbf66",
    d: "M16 1a15 15 0 1 0 15 15A15 15 0 0 0 16 1Z",
    className: "color56aaff svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M20 18h-8a6 6 0 0 0-6 6v2.71a1 1 0 0 0 .35.76 15 15 0 0 0 19.29 0 1 1 0 0 0 .35-.76V24A6 6 0 0 0 20 18Z",
    className: "color0478ed svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 11,
    r: 5,
    fill: "#000000",
    className: "color0478ed svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBond);
export default __webpack_public_path__ + "static/media/bond.e9f699f2e97bdf5b6305ba329f7bd8e8.svg";
export { ForwardRef as ReactComponent };